export const DOMAIN = 'https://6044318ba20ace001728ebad.mockapi.io/api'

export const STATUS_CODE = {
    SUCCESS: 200,
    NOT_FOUND: 404,
    SERVER_ERROR: 500,
}